const GET_BOUGHT_PRODUCTS_REQUSET = "getBoughtProducts/request";
const GET_BOUGHT_PRODUCTS_SUCCESS = "getBoughtProducts/success";
const GET_BOUGHT_PRODUCTS_ERROR = "getBoughtProducts/error";

const ADD_BOUGHT_PRODUCTS_REQUSET = "addBoughtProducts/request";
const ADD_BOUGHT_PRODUCTS_SUCCESS = "addBoughtProducts/success";
const ADD_BOUGHT_PRODUCTS_ERROR = "addBoughtProducts/error";

const DELETE_BOUGHT_PRODUCTS_REQUSET = "deleteBoughtProducts/request";
const DELETE_BOUGHT_PRODUCTS_SUCCESS = "deleteBoughtProducts/success";
const DELETE_BOUGHT_PRODUCTS_ERROR = "deleteBoughtProducts/error";

const CHANGE_AMOUNT_PRODUCTS_REQUEST = "changeAmountProducts/request";
const CHANGE_AMOUNT_PRODUCTS_SUCCESS = "changeAmountProducts/success";
const CHANGE_AMOUNT_PRODUCTS_ERROR = "changeAmountProducts/error";

export default {
  GET_BOUGHT_PRODUCTS_REQUSET,
  GET_BOUGHT_PRODUCTS_SUCCESS,
  GET_BOUGHT_PRODUCTS_ERROR,
  ADD_BOUGHT_PRODUCTS_REQUSET,
  ADD_BOUGHT_PRODUCTS_SUCCESS,
  ADD_BOUGHT_PRODUCTS_ERROR,
  DELETE_BOUGHT_PRODUCTS_REQUSET,
  DELETE_BOUGHT_PRODUCTS_SUCCESS,
  DELETE_BOUGHT_PRODUCTS_ERROR,
  CHANGE_AMOUNT_PRODUCTS_REQUEST,
  CHANGE_AMOUNT_PRODUCTS_SUCCESS,
  CHANGE_AMOUNT_PRODUCTS_ERROR,
};
